import { motion } from "framer-motion";
import { useLang } from "@/context/LangContext";

export default function SeoContent() {
  const { t } = useLang();
  const seo = t("seo");
  const fade = {
    initial: { opacity: 0, y: 34 },
    whileInView: { opacity: 1, y: 0 },
    viewport: { once: true, margin: "-60px" },
    transition: { duration: 0.7, ease: [0.16, 1, 0.3, 1] },
  };

  return (
    <section id="faq" className="py-24 lg:py-32 border-t border-white/10" data-testid="seo-content-section">
      <div className="mx-auto max-w-3xl px-6">
        <motion.div {...fade}>
          <h2 className="font-display text-3xl sm:text-4xl mb-6">{seo.h2a}</h2>
          {seo.paras.map((p, i) => (
            <p key={i} className="text-muted-foreground leading-relaxed mb-4">{p}</p>
          ))}
        </motion.div>

        <motion.div {...fade} className="mt-16">
          <h2 className="font-display text-3xl sm:text-4xl mb-8">{seo.howT}</h2>
          <div className="space-y-6">
            {seo.steps.map((s, i) => (
              <div key={i} className="flex gap-4">
                <span className="font-display text-3xl text-neon shrink-0">0{i + 1}</span>
                <div>
                  <h3 className="font-bold text-lg mb-1">{s.t}</h3>
                  <p className="text-sm text-muted-foreground leading-relaxed">{s.d}</p>
                </div>
              </div>
            ))}
          </div>
        </motion.div>

        <motion.div {...fade} className="mt-16">
          <h2 className="font-display text-3xl sm:text-4xl mb-8">{seo.featT}</h2>
          <ul className="grid sm:grid-cols-2 gap-3">
            {seo.feats.map((f, i) => (
              <li key={i} className="flex items-start gap-2.5 text-sm text-muted-foreground rounded-xl border border-white/10 bg-surface/50 p-4">
                <span className="mt-1.5 h-1.5 w-1.5 rounded-full bg-neon shrink-0" />
                {f}
              </li>
            ))}
          </ul>
        </motion.div>

        <motion.div {...fade} className="mt-16 space-y-10">
          {seo.devices.map((d, i) => (
            <div key={i}>
              <h2 className="font-display text-2xl sm:text-3xl mb-3">{d.t}</h2>
              <p className="text-muted-foreground leading-relaxed">{d.b}</p>
            </div>
          ))}
        </motion.div>

        <motion.div {...fade} className="mt-16">
          <h2 className="font-display text-3xl sm:text-4xl mb-8">{seo.faqT}</h2>
          <div className="space-y-3">
            {seo.faqs.map((f, i) => (
              <details key={i} className="rounded-xl border border-white/10 bg-surface/50 p-5 group" data-testid={`seo-faq-${i}`}>
                <summary className="font-bold cursor-pointer list-none flex items-center justify-between gap-3">
                  <h3 className="text-base">{f.q}</h3>
                  <span className="text-neon text-xl leading-none transition-transform duration-200 group-open:rotate-45">+</span>
                </summary>
                <p className="mt-3 text-sm text-muted-foreground leading-relaxed">{f.a}</p>
              </details>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
}
